/**
 * Past Events Table Configuration
 */

import React from 'react';
import { formatDateValue } from '../utils/dateUtils';
import EventStatusCell from '../components/misc/EventStatusCell';
import EventCityCell from '../components/misc/EventCityCell';
import EventRevenueCell from '../components/misc/EventRevenueCell';
import EventVenueCell from '../components/misc/EventVenueCell';
import { truncateString } from '../utils/string';
import nameFilter from '../components/filters/nameFilter';
import eventTypeFilter from '../components/filters/eventTypeFilter';
import cityFilter from '../components/filters/cityFilter';
import venueFilter from '../components/filters/venueFilter';
import startDateFilter from '../components/filters/startDateFilter';
import eventCategoryFilter from '../components/filters/eventCategoryFilter';
import isActiveFilter from '../components/filters/isActiveFitler';
import {
  EventCategoryCell,
  EventTypeCell,
  EventVerifiedVisibleCell,
} from '../components/misc/EventLocalizedCells';

export const PAST_EVENTS_TABLE = {
  entity: 'events-v2',
  defaults: {
    pageSize: 100,
    visible: { id: false },
    orderBy: { field: 'enddate', dir: 'desc' },
    limit: 100,
  },
  columns: [
    { field: 'id', headerName: 'ID', width: 100, filterable: false },
    {
      field: 'name',
      headerName: 'Name',
      width: 200,
      filterable: true,
      renderCell: (params) => truncateString(params.value, 50),
      filterOperators: nameFilter,
    },
    {
      field: 'type',
      headerName: 'Type',
      width: 150,
      filterable: true,
      renderCell: (params) => <EventTypeCell type={params.value} dateType={params.row.dateType} />,
      filterOperators: eventTypeFilter,
    },
    {
      field: 'venue',
      headerName: 'Venue',
      width: 200,
      filterable: true,
      renderCell: (params) => <EventVenueCell row={params.row} />,
      filterOperators: venueFilter,
    },
    {
      field: 'city',
      headerName: 'City',
      width: 100,
      filterable: true,
      renderCell: (params) => <EventCityCell row={params.row} />,
      filterOperators: cityFilter,
    },
    {
      field: 'category',
      headerName: 'Category',
      width: 125,
      filterable: true,
      renderCell: (params) => <EventCategoryCell categoryId={params.row.category} />,
      filterOperators: eventCategoryFilter,
    },
    {
      field: 'startdate',
      headerName: 'Started at',
      width: 150,
      filterable: true,
      renderCell: (params) => formatDateValue(params.row.startdate),
      filterOperators: startDateFilter,
    },
    {
      field: 'enddate',
      headerName: 'Ended at',
      width: 150,
      renderCell: (params) => formatDateValue(params.row.enddate),
      filterable: false,
    },
    {
      field: 'isVerified',
      headerName: 'Verified / Visible',
      width: 150,
      filterable: true,
      renderCell: (params) => <EventVerifiedVisibleCell event={params.row} />,
      filterOperators: isActiveFilter,
    },
    {
      field: 'totalRevenue',
      headerName: 'Total Revenue',
      width: 150,
      filterable: false,
      renderCell: (params) => (
        <EventRevenueCell
          event={params.row}
          eventId={params.row.uid || params.row.id}
          transformedFromV1={params.row.transformedFromV1}
        />
      ),
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 150,
      filterable: false,
      renderCell: (params) => <EventStatusCell event={params.row} />,
    },
  ],
};
